import React, {useMemo, useState} from 'react';
import * as commonColumnFormatters from '../../_common/column-formatters';
import {useAiReportsContext} from '../context/AiReportsContext';
import useInfiniteScrollControl from "../../_common/components/_custom-hooks/useInfiniteScrollControl";
import * as actions from "../_redux/aiReportsActions";
import {useTable} from "react-table";
import CommonGrid from "../../_common/components/CommonGrid";
import Spinner from "../../_common/components/Spinner";

export function AiReportsTable() {
  const [tableRows, setTableRows] = useState([]);
  const {
    canAnswer,
    reason,
    reportColumns
  } = useAiReportsContext();
  const columns = useMemo(() => [...reportColumns], [reportColumns]);
  const data = useMemo(
    () =>
      tableRows.map(item =>
        Object.fromEntries(
          Object.entries(item).map(([key, value]) => [
            key,
            typeof value === 'string' &&
            /^\d{4}-\d{2}-\d{2}T\d{2}:\d{2}:\d{2}(?:\.\d+)?(?:Z|[+-]\d{2}:\d{2})$/.test(value) &&
            !Number.isNaN(Date.parse(value))
              ? commonColumnFormatters.DateColumnFormatter(new Date(value))
              : value instanceof Date
                ? commonColumnFormatters.DateColumnFormatter(value)
                : commonColumnFormatters.BoldColumnFormatter(value),
          ])
        )
      ),
    [tableRows]
  );

  const infiniteScrollProps = useInfiniteScrollControl({
    currentStateStoreId: 'aiReports',
    UIContext: useAiReportsContext(),
    getNewEntities: actions.getReport,
    getNextEntities: actions.getNextReport,
    onEntitiesChange: (entities: never[]) => setTableRows(entities),
    dataLength: tableRows.length,
    scrollableTarget: 'scrollContainer',
    scrollThreshold: 0.9,
    loader: (
      <div className="spinner-container">
        <span className="spinner spinner-md spinner-primary" />
      </div>
    ),
    style: {
      overflow: 'inherit',
    },
    skipInitialFetch: true
  });

  const tableInstance = useTable<any>({columns, data});

  if (!canAnswer) {
    return (
      <div
        className={'bg-white border rounded p-4 mx-auto w-75 font-size-h5 d-flex align-items-center justify-content-center'}
        style={{overflowY: 'auto', minHeight: 200}}
      >
        {reason}
      </div>
    );
  }

  return (
    <CommonGrid
      infiniteScrollProps={infiniteScrollProps}
      tableProps={tableInstance}
    />
  );
}

